import apiClient from "../api/axiosConfig";
import { ApiResponse } from "../../types/api.types";

export interface TangoOrder {
  orderId: string;
  consecutiveNumber: number;
  total: number;
  createDate: string;
  clientName: string;
}

export interface TangoOrdersPage {
  orders: TangoOrder[];
  total: number;
}

export interface TangoOrderDetail {
  orderDetailId: string;
  productDescription: string | null;
  quantity: number;
  unitPrice: number;
  discountPercentage: number;
  totalPrice: number;
}

export const tangoOrderService = {
  async getDetails(orderId: string, signal?: AbortSignal): Promise<TangoOrderDetail[]> {
    const response = await apiClient.get<ApiResponse<TangoOrderDetail[]>>(
      `/api/orders/${encodeURIComponent(orderId)}/tango-details`, { signal },
    );
    return response.data.data;
  },
  async getOrders(page: number, rowPerPage: number, dateFrom: string, dateTo: string, signal?: AbortSignal) {
    const response = await apiClient.get<ApiResponse<TangoOrdersPage>>("/api/orders/sent-for-tango", {
      params: { page, rowPerPage, dateFrom, dateTo }, signal,
    });
    return response.data.data;
  },
  async exportOrders(orderIds: string[]): Promise<Blob> {
    try {
      const response = await apiClient.post<Blob>("/api/orders/export-tango", { orderIds }, { responseType: "blob" });
      return response.data;
    } catch (error) {
      const response = (error as { response?: { data?: Blob } }).response;
      if (response?.data instanceof Blob) {
        const text = await response.data.text();
        let message = "No se pudo generar el Excel de TANGO.";
        try { message = JSON.parse(text).message || message; } catch { /* Error sin cuerpo JSON. */ }
        throw new Error(message);
      }
      throw error;
    }
  },
};
